import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { StorageTypes, TrackProperty, TrackPropertyApiResponse } from '@rma/campaigns/private/domain-track-campaign';
import { appendToRmaApiUrl } from '@rma/common-ui-ng/util';
import { map, Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiTrackPropertyStorageService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public readonly storageType = StorageTypes.Api;
  private trackedPropertyCodes: string[] = [];

  public trackProperty(campaignCode: string, payload: { firstName: string; email: string }): Observable<TrackProperty> {
    const url = this.rmaApiUrl(`Users/Me/Track/Campaign/Code-${campaignCode}`);
    return this.httpClient
      .put<TrackPropertyApiResponse>(url, {
        FirstName: payload.firstName,
        EmailAddress: payload.email,
      })
      .pipe(
        map((response) => ({
          trackId: response.trackId,
          email: payload.email,
          trackPropertyCount: response.trackPropertyCount,
        })),
      );
  }

  public untrackPropertyByCampaignCode(campaignCode: string): Observable<void> {
    const url = this.rmaApiUrl(`Users/Me/Track/Campaign/Code-${campaignCode}`);
    return this.httpClient.delete<void>(url);
  }

  public untrackPropertyByTrackId(trackId: string): void {
    const url = this.rmaApiUrl(`Users/Me/Track/Campaign/${trackId}`);
    this.httpClient.delete(url).subscribe();
  }

  public getTrackedPropertyCodes(forceReload: boolean): Observable<string[]> {
    if (this.trackedPropertyCodes && this.trackedPropertyCodes.length > 0 && !forceReload) {
      return of(this.trackedPropertyCodes);
    }
    const url = this.rmaApiUrl('Users/Me/Track/Campaigns');

    return this.httpClient.get<string[]>(url);
  }
}
